// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import Navbar from './components/Global/Navbar';
import Home from './components/Home';
import ClientList from './components/ClientList';
import ClientForm from './components/ClientForm';
import OrdersPage from './pages/OrdersPage';
import PrivateRoute from './components/PrivateRoute';
import LoginPage from './pages/LoginPage';
import UserPage from './pages/UserPage';
import UserForm from './components/UserForm';
import ChangePassswordPage from './pages/ChangePasswordPage';
import SalesRepsPage from './pages/SalesRepsPage';
import SalesRepForm from './components/SalesRepForm';
import CarriersPage from './components/CarrierList';
import CarrierForm from './components/CarrierForm';
import DeliveryList from './components/DeliveryList';
import ProductList from './components/ProductList';
import DeliveryDispatch from './components/DeliveryDispatch';
import { TimeZoneProvider } from './context/TimeZoneContext';
import ErrorBoundary from './context/ErrorBoundary';
import OrderDetail from './components/Orders/OrderDetail';
import OrderList from './components/Orders/OrderList';
import NewOrderForm from './components/Orders/NewOrderForm';
import OrderItemsByCarrierView from './components/OrderItemsByCarrierView';
import EventsPage from './pages/EventsPage';
import CommissionReportSalesRepPage from './pages/CommissionReportSalesRepPage';
import LogsPage from './pages/LogsPage';
import CommissionsCarrierHandlePage from './pages/CommissionsCarrierHandlePage';
import CommissionCarrierPage from './pages/CommissionCarrierPage';
import ProductVariantsPage from './pages/ProductVariantsPage';
import SpecialProductsManagementPage from './pages/SpecialProductsManagementPage';
import TelegramChannelAssignmentsPage from './pages/TelegramChannelAssignmentsPage';
import CarrierZipPrefixesPage from './pages/CarrierZipPrefixesPage';
import OrdersMapPage from './pages/OrdersMapPage';
import ZipCodeMapPage from './pages/ZipCodeMapPage';
import LeadsPage from './pages/LeadsPage';
import SalesLeadManagementPage from './pages/SalesLeadManagementPage';
import LeadAccountsPage from './pages/LeadAccountsPage';
import LeadAccountDailyStatsPage from './pages/LeadAccountDailyStatsPage';
import DailyLeadStatsPage from './pages/DailyLeadStatsPage';
import AnalyticsPage from './pages/AnalyticsPage';

function App() {
  return (
    <ErrorBoundary>
      <TimeZoneProvider>
        <Router>
          <Navbar />
          <div className="container-fluid">
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route path="/" element={<PrivateRoute element={<Home />} />} />
              
              <Route path="/clients" element={<PrivateRoute element={<ClientList />} />} />
              <Route path="/clients/edit/:id" element={<PrivateRoute element={<ClientForm />} />} />
              <Route path="/clients/new" element={<PrivateRoute element={<ClientForm />} />} />

              <Route path="/orders/*" element={<PrivateRoute element={<OrdersPage />} />} />
              <Route path="/orders/new/*" element={<PrivateRoute element={<NewOrderForm />} />} />
              <Route path="/orders/:orderId/*" element={<PrivateRoute element={<OrderDetail />} />} />
              <Route path="/orders/:id/related/*" element={<PrivateRoute element={<OrdersPage />} />} />
              <Route path="/calendar" element={<PrivateRoute element={<OrderList />} />} />
              <Route path="/ordersByCarrier" element={<PrivateRoute element={<OrderList />} />} />
              <Route path="/transport" element={<PrivateRoute element={<OrderList />} />} />
              <Route path="/salesreps/commissions" element={<PrivateRoute element={<CommissionReportSalesRepPage />} />} />
              <Route path="/carriers/commissions" element={<PrivateRoute element={<CommissionCarrierPage />} />} />

              <Route path="/users" element={<PrivateRoute element={<UserPage />} />} />
              <Route path="/users/edit/:id" element={<PrivateRoute element={<UserForm />} />} />
              <Route path="/users/new" element={<PrivateRoute element={<UserForm />} />} />

              <Route path="/salesreps" element={<PrivateRoute element={<SalesRepsPage />} />} />
              <Route path="/salesreps/edit/:id" element={<PrivateRoute element={<SalesRepForm />} />} />
              <Route path="/salesreps/new" element={<PrivateRoute element={<SalesRepForm />} />} />

              <Route path="/carriers" element={<PrivateRoute element={<CarriersPage />} />} />
              <Route path="/carriers/edit/:id" element={<PrivateRoute element={<CarrierForm />} />} />
              <Route path="/carriers/new" element={<PrivateRoute element={<CarrierForm />} />} />

              <Route path="/carrier-zip-prefixes/*" element={<PrivateRoute element={<CarrierZipPrefixesPage />} />} />

              <Route path="/delivery" element={<PrivateRoute element={<DeliveryList />} />} />
              <Route path="/delivery/dispatch/:id" element={<PrivateRoute element={<DeliveryDispatch />} />} />
              <Route path="/orderItemsByCarrier" element={<PrivateRoute element={<OrderItemsByCarrierView />} />} />

              <Route path="/products" element={<PrivateRoute element={<ProductList />} />} />
              <Route path="/product-variants" element={<PrivateRoute element={<ProductVariantsPage />} />} />
              <Route path="/special-products" element={<PrivateRoute element={<SpecialProductsManagementPage />} />} />
              <Route path="/events" element={<PrivateRoute element={<EventsPage />} />} />
              <Route path="/carriers/commissions/products" element={<PrivateRoute element={<CommissionsCarrierHandlePage />} />} />
              <Route path="/telegram-channel-assignments/*" element={<PrivateRoute element={<TelegramChannelAssignmentsPage />} />} />
              <Route path="/orders-map" element={<PrivateRoute element={<OrdersMapPage />} />} />
              <Route path="/zipcode-map" element={<PrivateRoute element={<ZipCodeMapPage />} />} />
              <Route path="/logs" element={<PrivateRoute element={<LogsPage />} />} />
              <Route path="/lead-assignment/*" element={<PrivateRoute element={<LeadsPage />} />} />
              <Route path="/lead-management/*" element={<PrivateRoute element={<SalesLeadManagementPage />} />} />
              <Route path="/lead-accounts/*" element={<PrivateRoute element={<LeadAccountsPage />} />} />
              <Route path="/lead-account-history/*" element={<PrivateRoute element={<LeadAccountDailyStatsPage />} />} />
              <Route path="/daily-lead-stats/*" element={<PrivateRoute element={<DailyLeadStatsPage />} />} />
              <Route path="/analytics" element={<PrivateRoute element={<AnalyticsPage />} />} />
              <Route path="/settings" element={<PrivateRoute element={<ChangePassswordPage />} />} />
            </Routes>
          </div>
        </Router>
      </TimeZoneProvider>
    </ErrorBoundary>
  );
}

export default App;
